
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { MdOutlineArrowBackIos } from "react-icons/md";
import { useDispatch } from "react-redux";
import { showModal } from "../../../features/modal/modalSlice";
import YuklemeCityTownInput from "../sections/yukleme/inputs/YuklemeCityTownInput";
import YuklemeAdresInput from "../sections/yukleme/inputs/YuklemeAdresInput";
const Container = styled.div`

    height: 100vh;
    width: 420px;
    border-right: 1px solid ${({theme}) => theme.mainTextColor};
    overflow: auto;

    .top-container{
        width: 100%;
        margin-bottom: 30px;
        padding: 20px;
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
    }

    .route-container{
        width: 100%;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 30px;

        .route-item{
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 10px;

            h3{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

        }

    }
`

const AddLoadMapWideRouteSide = ({route}) => {
    const dispatch = useDispatch()
  return (
    <Container>
        <div className="top-container">
            <Btn color="#E85446" borderColor="#E85446" bgColor="flex" width={"100%"} handleClick={() => dispatch(showModal(null))}><MdOutlineArrowBackIos/> Geri Dön</Btn>
        </div>
        <div className="route-container">
        {
            route.map((item, i) => (
                <div className="route-item">
                    <h3>{i+1}. Rota Noktası {item.locationType === "yukleme" ? "Yükleme Noktası" : "Boşaltma Noktası"}</h3>
                    <YuklemeCityTownInput
                        data={item}
                        name={"yuklemeCityTown" + i}
                        isRequired={true}
                        inputWidth="100%"
                    />

                    <YuklemeAdresInput
                        data={item}
                        name={"yuklemeAdres" + item.id}
                        isRequired={false}
                        inputWidth="100%"
                    />
                </div>
            ))
        }
        </div>
    </Container>
  )
}

export default AddLoadMapWideRouteSide